import currency from "currency.js";
import { iban, studentid } from "../../../sql/classy/types";
import { invoiceFull } from "../../domain/finance/types";
import { isNil } from "../../lib/istype";

export function getInvoiceDirectDebitInfoStatus(
  invoice: {
    expectedpayments:
      | {
          amount_left: currency;
          periodic_payment_method: "direct_debit" | "manual" | null;
        }[]
      | null;
  } | null,
  stu: {
    id: studentid;
    iban: iban | null;
    name_on_iban: string;
    direct_debit_allowed: boolean;
  },
): "no_unpaid_direct_debits" | "ok" | "needs_info" {
  if (invoice === null) {
    return "no_unpaid_direct_debits";
  }
  const invHasUnpaidDirectDebits = (invoice.expectedpayments || []).some(
    (ep) =>
      ep.amount_left.intValue > 0 &&
      ep.periodic_payment_method === "direct_debit",
  );

  if (invHasUnpaidDirectDebits === false) {
    return "no_unpaid_direct_debits";
  }

  if (
    stu.direct_debit_allowed === true &&
    !isNil(stu.iban) &&
    stu.name_on_iban.trim().length > 0
  ) {
    return "ok" as const;
  } else {
    return "needs_info" as const;
  }
}
